import dayjs from 'dayjs';

/** Mantine 8+ emits timezone-free date strings from all dates components. */
export type MantineDateValue = string | null;

export const toMantineDate = (value?: Date | string | null): MantineDateValue => {
  if (!value) {
    return null;
  }

  return dayjs(value).format('YYYY-MM-DD');
};

/** Parse a Mantine date string as local midnight, avoiding UTC date shifts. */
export const fromMantineDate = (value: MantineDateValue): Date | null => {
  if (!value) {
    return null;
  }

  const parsed = dayjs(value, 'YYYY-MM-DD', true);
  return parsed.isValid() ? parsed.toDate() : null;
};

export const toMantineDateTime = (value?: Date | string | null): MantineDateValue => {
  if (!value) {
    return null;
  }

  return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
};

export const fromMantineDateTime = (value: MantineDateValue): Date | null => {
  if (!value) {
    return null;
  }

  const parsed = dayjs(value, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD'], true);
  return parsed.isValid() ? parsed.toDate() : null;
};
